import { render, staticRenderFns } from "./newUserFrom.vue?vue&type=template&id=0624c42c&scoped=true"
import script from "./newUserFrom.vue?vue&type=script&lang=js"
export * from "./newUserFrom.vue?vue&type=script&lang=js"
import style0 from "./newUserFrom.vue?vue&type=style&index=0&id=0624c42c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0624c42c",
  null
  
)

export default component.exports